export function networkStatusAction(onLine) {
  return {
    type: 'NETWORK_STATUS',
    onLine,
  };
}
